import React from "react";

/**
 * Reusable VIP Icon Component
 * Target/Badge SVG icon with dynamic stroke weight based on active state
 */
const VIPIcon = ({ className = "w-7 h-7", isActive = false, ...props }) => {
  // Generate unique gradient ID to avoid conflicts when multiple instances are rendered
  const gradientId = `primaryGradientVIP-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${className} flex-shrink-0`}
      {...props}
    >
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#FFE48A" />
          <stop offset="50%" stopColor="var(--color-primary)" />
          <stop offset="100%" stopColor="#A87A1F" />
        </linearGradient>
      </defs>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={isActive ? "2" : "1.5"}
        stroke={`url(#${gradientId})`}
        d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      />
    </svg>
  );
};

export default VIPIcon;
